import React, { useContext } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import StageBackground from '../../../DeviationBackground/StageBackground';
import DeviationFullView from '../../../DeviationViews/Full';
import DuperbrowsePaddles from '../../../Duperbrowse/DuperbrowsePaddles';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';

import s from './SimpleStage.scss';

export interface Props {
  deviation: PapiDeviation;
}

const SimpleStage: React.FC<Props> = ({ deviation }) => {
  const { needsSubscription } = useSubscriptionTier(deviation);
  const { isTheater } = useDeviationViewContext();

  const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);

  return (
    <div className={cn(s['stage'], needsSubscription && s['stage-locked'])}>
      <StageBackground deviation={deviation} />
      <div
        className={cn(
          s['stage-content'],
          needsSubscription && s['content-locked'],
          isTheater && s['content-locked-theater']
        )}
      >
        <DeviationFullView deviation={deviation} />
      </div>
      <DuperbrowsePaddles className={s['duperbrowse']} />

      {isSubscriptionPurchaseFTUEBeingShown && <SubscriptionPurchaseFTUE />}
    </div>
  );
};
SimpleStage.displayName = 'SimpleStage';

export default SimpleStage;
